// src/components/PieChart.tsx
import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import { Box, Heading, Text, useMediaQuery } from "@chakra-ui/react";
import { GuestDataItemGrid, GuestInviteStatus } from "../types/guest";

Chart.register(ArcElement, Tooltip, Legend);
Chart.defaults.backgroundColor = "transparent"

interface PieChartProps {
  analyticsData: GuestDataItemGrid[];
  borderColor?: string;
  size?: string;
  totalValue: number; // total value to calculate percentage
}

const colorMap: Record<GuestInviteStatus, string> = {
  [GuestInviteStatus.Accepted]: "#54C080",
  [GuestInviteStatus.Pending]: "#e0ac2b",
  [GuestInviteStatus.Rejected]: "#BB2727",
};

const PieChart: React.FC<PieChartProps> = ({ analyticsData, borderColor, size, totalValue }) => {
  const data = analyticsData.map((item) => ({
    ...item,
    color: colorMap[item.name],
  }));
  // Extracting values and colors from data array
  const values = data.map((item) => item.value);
  const colors = data.map((item) => item.color);


  const [isShorterThan580] = useMediaQuery("(max-height: 580px)");


  // Setting up chart data
  const chartData = {
    datasets: [
      {
        data: values,
        backgroundColor: colors,
        borderWidth: 10,
        circumference: 360,
        borderColor: borderColor || "#F9F9F9", // Gap color
        borderRadius: 20, // Curved edges
        hoverOffset: 0,
      },
    ],
  };

  // Chart.js options
  const options = {
    cutout: "70%", // Doughnut thickness
    plugins: {
      tooltip: {
        enabled: false, // Disable tooltips for clean UI
      },
    },
    events: [], // Disable all events, including hover
    responsive: true,
    animation: {
      duration: 0, // Disable animations
    },
  };

  // Custom center text (like '12k')
  const CenterText = () => {
    return (
          <Text fontSize={"2xl"} fontWeight={"bold"} 
          position={"absolute"}>
            {totalValue}
          </Text>
      
    );
  };

  const resize = isShorterThan580
    ? "130px"
    : "150px";

  return (
    <Box textAlign={"center"}> 
    <Heading as="h2" fontFamily={"font4"} fontWeight={500}>RSVP</Heading>
    <Box position="relative" width={size || resize} height={size || resize}
    display={"flex"}
    justifyContent={"center"}
    alignItems={"center"}>
      <Doughnut data={chartData} options={options} />
      <CenterText />
    </Box>
    </Box>
  );
};

export default PieChart;
